import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as ARTICLE_TYPE} from '../creators/article';
import history from "../libs/history";
import createLink from "../libs/createLink";

export function* createSuccess(action) {
    try {
        yield put({type: "ARTICLES_ADD", data : action.payload});
        yield put({type: "USER_ARTICLES_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "ARTICLES_DELETE", data : action.payload});
        yield put({type: "USER_ARTICLES_DELETE", data : action.payload});
        history.push(createLink('articles'));

    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "ARTICLES_UPDATE", data : action.payload});
        yield put({type: "USER_ARTICLES_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchArticle() {
    yield takeEvery(ARTICLE_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(ARTICLE_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(ARTICLE_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchArticle;

